import { Divider } from "@chakra-ui/react";
import React from "react";
export const IonDivider = () => {
  return /* @__PURE__ */ React.createElement(Divider, { mt: "16px", mb: "16px" });
};
